import React from "react";
import {
  PrimaryButton as MSPrimaryButton,
  Spinner,
  SpinnerSize,
  Stack,
  Text,
} from "@fluentui/react";

const PrimaryButton = ({ loading, text, btnType = 'submit', ...rest }) => {
  return (
    <MSPrimaryButton type={btnType} {...rest}>
      <Stack
        tokens={{
          childrenGap: 10,
        }}
        verticalAlign={"center"}
        horizontal
      >
        {loading ? <Spinner size={SpinnerSize.small} /> : <Text>{text}</Text>}
      </Stack>
    </MSPrimaryButton>
  );
};

export default PrimaryButton;
